import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const TimeRegistrationIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 18.8C14.8601 18.8 18.8 14.8601 18.8 10C18.8 5.13989 14.8601 1.2 10 1.2C5.13989 1.2 1.2 5.13989 1.2 10C1.2 14.8601 5.13989 18.8 10 18.8ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 6.11875C10.3314 6.11875 10.6 6.38738 10.6 6.71875V10C10.6 10.3314 10.3314 10.6 10 10.6C9.66863 10.6 9.4 10.3314 9.4 10V6.71875C9.4 6.38738 9.66863 6.11875 10 6.11875Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.57578 9.57569C9.81012 9.3414 10.19 9.34144 10.4243 9.57578L14.5254 13.6778C14.7597 13.9121 14.7597 14.292 14.5253 14.5263C14.291 14.7606 13.9111 14.7606 13.6768 14.5262L9.57569 10.4242C9.3414 10.1899 9.34144 9.80998 9.57578 9.57569Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

TimeRegistrationIcon.propTypes = iconPropTypes;
TimeRegistrationIcon.defaultProps = iconDefaultProps;
